// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as React from "react";
import * as Atom_Logo from "../../atom/Atom_Logo.bs.js";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Atom_Divider from "../../atom/Atom_Divider.bs.js";
import * as Atom_Text_Ds from "../../atom/Atom_Text_Ds.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";

function Organism_European(Props) {
  var text = Props.text;
  if (text !== undefined) {
    return React.createElement(React.Fragment, undefined, React.createElement(Atom_Column.make, {
                    blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S")),
                    children: null,
                    innerSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S"),
                    rules: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [CssJs.alignItems(CssJs.center)])
                  }, React.createElement(Atom_Text.make, {
                        children: text,
                        kind: "span",
                        style: Atom_Text_Ds.Footer.european
                      }), React.createElement(Atom_Logo.make, {
                        logo: "EuropeanFlag"
                      })), React.createElement(Atom_Divider.make, {
                    style: Atom_Divider.footer
                  }));
  } else {
    return null;
  }
}

var make = Organism_European;

export {
  make ,
}
/* CssJs Not a pure module */
